/*
  NerdMatic — stima di consegna nativa + legenda della disponibilità.
  Task "Classificazione tempi di spedizioni prodotti" (5071) — 2026-09-15.

  Sostituisce l'app C-EDD. Differenza: i giorni di preparazione arrivano dallo
  stato del singolo prodotto, non da una regola uguale per tutto il catalogo.
  Le date le calcola qui il browser, sull'orologio di chi guarda, contando solo
  i giorni lavorativi.
*/
(function () {
  'use strict';

  // lo snippet del badge e quello della consegna caricano lo stesso file
  if (window.__nmConsegnaAvviato) return;
  window.__nmConsegnaAvviato = true;

  var GIORNI_LAVORATIVI = [1, 2, 3, 4, 5]; // lunedì → venerdì

  function eLavorativo(data) {
    return GIORNI_LAVORATIVI.indexOf(data.getDay()) !== -1;
  }

  // 0 giorni lavorativi = oggi stesso, ma se oggi è sabato slitta a lunedì
  function aggiungiLavorativi(data, giorni) {
    var d = new Date(data.getTime());
    d.setHours(12, 0, 0, 0); // mezzogiorno: niente sorprese con l'ora legale
    while (!eLavorativo(d)) d.setDate(d.getDate() + 1);
    var fatti = 0;
    while (fatti < giorni) {
      d.setDate(d.getDate() + 1);
      if (eLavorativo(d)) fatti++;
    }
    return d;
  }

  var fmtCompleto = new Intl.DateTimeFormat('it-IT', { weekday: 'short', day: 'numeric', month: 'short' });
  var fmtGiornoMese = new Intl.DateTimeFormat('it-IT', { day: 'numeric', month: 'short' });
  var fmtSoloGiorno = new Intl.DateTimeFormat('it-IT', { day: 'numeric' });

  // Le colonne sono larghe un centinaio di pixel: una data su due righe
  // sfalsava l'altezza dei tre passi. Quindi forme corte, sempre su una riga.
  //   stesso giorno      → "Gio 17 set"
  //   stesso mese        → "17 – 18 set"
  //   mesi diversi       → "30 set – 2 ott"
  function intervallo(da, a) {
    if (da.getTime() === a.getTime()) return maiuscola(fmtCompleto.format(da));
    if (da.getMonth() === a.getMonth()) {
      return fmtSoloGiorno.format(da) + ' – ' + fmtGiornoMese.format(a);
    }
    return fmtGiornoMese.format(da) + ' – ' + fmtGiornoMese.format(a);
  }

  function maiuscola(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function dueCifre(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function avviaWidget(widget) {
    var datiEl = widget.parentNode.querySelector('.nm-consegna__dati') || document.querySelector('.nm-consegna__dati');
    var cfg;
    try {
      cfg = JSON.parse(datiEl.textContent);
    } catch (e) {
      return;
    }

    var elCutoff = widget.querySelector('[data-nm-cutoff]');
    var elCountdown = widget.querySelector('[data-nm-countdown]');

    function disegna() {
      var ora = new Date();
      var limite = new Date(ora.getFullYear(), ora.getMonth(), ora.getDate(), cfg.cutoffOra, cfg.cutoffMinuto, 0, 0);
      var inTempo = ora < limite && eLavorativo(ora);

      // fuori orario o nel fine settimana la preparazione parte dal giorno lavorativo dopo
      var partenza = inTempo ? ora : aggiungiLavorativi(ora, eLavorativo(ora) ? 1 : 0);

      var spedizioneDa = aggiungiLavorativi(partenza, cfg.prepMin);
      var spedizioneA = aggiungiLavorativi(partenza, cfg.prepMax);
      var consegnaDa = aggiungiLavorativi(spedizioneDa, cfg.transitoMin);
      var consegnaA = aggiungiLavorativi(spedizioneA, cfg.transitoMax);

      scrivi(widget, 'ordinato', 'Oggi');
      scrivi(widget, 'spedito', intervallo(spedizioneDa, spedizioneA));
      scrivi(widget, 'consegnato', intervallo(consegnaDa, consegnaA));

      if (!elCutoff) return;
      if (!inTempo) {
        elCutoff.hidden = true;
        return;
      }
      elCutoff.hidden = false;
      var mancano = Math.max(0, Math.floor((limite - ora) / 1000));
      var h = Math.floor(mancano / 3600);
      var m = Math.floor((mancano % 3600) / 60);
      var s = mancano % 60;
      if (elCountdown) elCountdown.textContent = dueCifre(h) + ':' + dueCifre(m) + ':' + dueCifre(s);
    }

    disegna();
    setInterval(disegna, 1000);
  }

  function scrivi(widget, nome, testo) {
    var el = widget.querySelector('[data-nm-data="' + nome + '"]');
    if (el) el.textContent = testo;
  }

  function avviaLegenda() {
    document.addEventListener('click', function (e) {
      var apri = e.target.closest ? e.target.closest('.nm-disp__apri') : null;
      if (!apri) return;
      var pannello = document.getElementById(apri.getAttribute('aria-controls'));
      if (!pannello) return;
      var aperto = apri.getAttribute('aria-expanded') === 'true';
      apri.setAttribute('aria-expanded', aperto ? 'false' : 'true');
      pannello.hidden = aperto;
    });
  }

  function avvia() {
    var widgets = document.querySelectorAll('[data-nm-consegna]');
    for (var i = 0; i < widgets.length; i++) avviaWidget(widgets[i]);
    avviaLegenda();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia, { once: true });
  } else {
    avvia();
  }
})();
